import { ref } from "vue"

// for extending the initial loading time
export function useDelayRef(
  sourceRef,
  delay = 300,
  conditionToDoSomethingImmediate = newValue => newValue === true,
  doImmediate = () => true,
  doAfterDelay = () => false,
) {
  // give timeId an initial value that could serve as a delay flag
  // to prevent else {} clause to run immediately when sourceRef initial value is false
  let timeId = 123
  const _ref = ref(sourceRef.value)

  watch(sourceRef, () => {
    if (conditionToDoSomethingImmediate(sourceRef.value) === true) {
      // console.log('condition to do something IMMEDIATELY is met')

      // console.log('Cancel previous scheduled callback')
      clearTimeout(timeId)

      // console.log('Do something immediately')
      _ref.value = doImmediate(sourceRef.value)

      // console.log('and schedule a callback to do after delay')
      timeId = setTimeout(() => {
        // console.log('setTimeout is called')
        // console.log('clear timeId which can represent that delay has passed')
        timeId = null

        // need to get latest value directly from sourceRef because of setTimeout
        if (conditionToDoSomethingImmediate(sourceRef.value) === true) {
          // console.log('but return because condition to do something later is NOT met')
          return
        }

        // console.log('time to call doAfterDelay')
        _ref.value = doAfterDelay(sourceRef.value)
      }, delay)
    }
    else {
      // console.log('condition to do something LATER is met')

      if (timeId) {
        // console.log('timeId presents indicating that delay has not passed, so wait setTimeout to run')
        return
      }

      // console.log('call doAfterDelay immediately because delay has passed')
      _ref.value = doAfterDelay(sourceRef.value)
    }
  },
  {
    immediate: true,
  })

  return _ref
}
